import axiosAPI from '../axiosAPI';

/**
 * Service para gerenciar assinaturas com a API do Asaas
 */
export const subscriptionService = {
  /**
   * Criar nova assinatura
   * @param {number} planId - ID do plano (1-5)
   * @param {string} billingType - Tipo de pagamento: 'CREDIT_CARD', 'BOLETO', 'PIX'
   * @param {string} couponCode - Código do cupom (opcional)
   */
  async subscribe(planId, billingType, couponCode = null) {
    const payload = {
      plan_id: planId,
      billing_type: billingType
    };
    
    if (couponCode) {
      payload.coupon_code = couponCode;
    }
    
    const response = await axiosAPI.post('/subscriptions/subscribe', payload);
    return response.data;
  },

  /**
   * Buscar assinatura atual do usuário
   */
  async getCurrent() {
    const response = await axiosAPI.get('/subscriptions/current');
    return response.data;
  },

  /**
   * Fazer upgrade de plano
   * @param {number} planId - ID do novo plano
   * @param {string} couponCode - Código do cupom (opcional)
   */
  async upgrade(planId, couponCode = null) {
    const payload = {
      plan_id: planId
    };
    
    if (couponCode) {
      payload.coupon_code = couponCode;
    }
    
    const response = await axiosAPI.post('/subscriptions/upgrade', payload);
    return response.data;
  },

  /**
   * Cancelar assinatura atual
   */
  async cancel() {
    const response = await axiosAPI.post('/subscriptions/cancel');
    return response.data;
  },

  /**
   * Buscar histórico de assinaturas
   */
  async getHistory() {
    const response = await axiosAPI.get('/subscriptions/history');
    return response.data;
  },

  /**
   * Buscar histórico de pagamentos da assinatura ativa
   */
  async getPayments() {
    const response = await axiosAPI.get('/subscriptions/payments');
    return response.data;
  },

  /**
   * Enviar documento OAB para análise de Jovem Advogado
   */
  async uploadYoungLawyerOab(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_category', 'jovem_advogado');
    formData.append('file_title', `OAB-${Date.now()}`);

    const response = await axiosAPI.post('/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  /**
   * Criar solicitação Jovem Advogado
   */
  async requestYoungLawyerApproval(planId, oabUserFileId, requestedCouponCode = null) {
    const payload = {
      plan_id: planId,
      oab_user_file_id: oabUserFileId,
    };

    if (requestedCouponCode) {
      payload.requested_coupon_code = requestedCouponCode;
    }

    const response = await axiosAPI.post('/subscriptions/jovem-advogado/request', payload);
    return response.data;
  },

  /**
   * Buscar status da solicitação Jovem Advogado
   */
  async getYoungLawyerStatus() {
    const response = await axiosAPI.get('/subscriptions/jovem-advogado/status');
    return response.data;
  },
};
